class ValidationUtils {
    static createErrors(form, field) {
        if (form && form.fields && form.fields[field] && form.fields[field].dirty && form.fields[field].errors.length > 0)
            return this.errorTexts[form.fields[field].errors[0]];
        return null;
    }
    static isNumber(param) {
        if (!isNaN(parseFloat(param)) && isFinite(param)) {
            return {
                valid: true,
                name: 'is-number'
            };
        }
        else {
            return {
                valid: false,
                name: 'is-number'
            };
        }
    }
}
ValidationUtils.errorTexts = {
    'required': 'See väli on kohustuslik',
    'is-number': 'See väli peab sisaldama numbreid'
};
export default ValidationUtils;
